import { ids as requirementIds } from '../job/requirement/Id';

export const ids = ['unknown', ...requirementIds] as const;
